var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHmm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 130,
    viewBox: "0 0 184 130",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(24381 3793)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 184,
    height: 130,
    transform: "translate(-24381 -3793)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24629.346 -4159.315)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(250 392.884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.114,450.228l-16.877-16.4H407.928v58.192l17.626,4.28V458.6l15.56,15.087L456.685,458.6v37.7l17.626-4.28V433.824H457.991Z",
    transform: "translate(-350.995 -419.065)",
    fill: "#202857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.087,411.813l-13.276-12.925H250v-5.994h79.246l10.866,10.579,11.015-10.589h79.123v5.995H353.542Z",
    transform: "translate(-250.001 -392.884)",
    fill: "#ee242d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 14.759)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.452,448.525H267.158v-14.7H250v44.329l17.158,4.189v-17.29h17.294v21.5l17.158,4.167v-56.9H284.452Z",
    transform: "translate(-250 -433.824)",
    fill: "#202857"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.445,433.823l-8.8,8.437-8.805-8.437h-17v56.9l17.1-4.163V456.513l8.707,8.343,8.709-8.343v25.8l17.095-4.165V433.823Z",
    transform: "translate(-478.196 -433.823)",
    fill: "#202857"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHmm);
export default __webpack_public_path__ + "static/media/hmm.787451e3fd6483fefb3109a640650d95.svg";
export { ForwardRef as ReactComponent };